import listSaga from './listSaga'
import editSpeakerSaga from './editSpeakerSaga'
import oneSpeakerSaga from './oneSpeakerSaga'
import deleteSpeakerSaga from './deleteSpeakerSaga'
import createSpeakerSaga from './createSpeakerSaga'

const speakersSagas = [listSaga(), oneSpeakerSaga(), editSpeakerSaga(), deleteSpeakerSaga(), createSpeakerSaga()]

export default speakersSagas
